import { Text, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import type { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { useTranslation } from 'react-i18next'
import { Link } from 'lucide-react-native'
import { Button, IconBadge } from '@chillout/ui'
import { Card } from '../../shared/Card'
import { CashierPublicLayout } from '../shared/CashierPublicLayout'
import type { CashierStackParamList } from '../../../navigation/types'

type Nav = NativeStackNavigationProp<CashierStackParamList, 'Pairing'>

export function PairingScreen() {
  const { t } = useTranslation()
  const navigation = useNavigation<Nav>()

  return (
    <CashierPublicLayout>
      <View className="flex-1 items-center justify-center px-6 pb-10">
        <Card className="w-full max-w-[480px] items-center px-8 py-10">
          <IconBadge
            Icon={Link}
            accessibilityLabel={t('cashierPairing.iconAccessibilityLabel')}
            className="h-[84px] w-[84px]"
            iconSize={42}
          />
          <Text className="mt-6 text-center text-3xl font-bold text-primary">
            {t('cashierPairing.title')}
          </Text>
          <Text className="mt-3 text-center text-base lg:text-lg text-secondary">
            {t('cashierPairing.subtitle')}
          </Text>
          <View className="mt-10 w-full gap-3">
            <Button
              label={t('cashierPairing.scanQRButton')}
              onPress={() => navigation.navigate('PairingInput', { initialMode: 'scan' })}
              accessibilityLabel={t('cashierPairing.scanQRButton')}
            />
            <Button
              label={t('cashierPairing.enterCodeButton')}
              onPress={() => navigation.navigate('PairingInput', { initialMode: 'code' })}
              variant="outline"
              accessibilityLabel={t('cashierPairing.enterCodeButton')}
            />
          </View>
        </Card>
      </View>
    </CashierPublicLayout>
  )
}
